import { createApp } from 'vue'
import ProductDetailsOtc from './ProductDetailsOtc.vue'

document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('product-details-otc')
    if (!el) return

    const productId       = Number(el.dataset.productid)
    const praeparatId     = Number(el.dataset.praeparatid)
    const hidePflichttext = el.dataset.hidepflichttext === 'true'

    createApp(ProductDetailsOtc, { productId, praeparatId, hidePflichttext })
        .mount(el)
})
